<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section --->
        <app-menus></app-menus>
        <!-- Menu section End -->
        <div class="app-main__outer">
            <div class="app-main__inner">
                <!-- --------------- -->
                <div class="app-page-title">
                    <div class="page-title-wrapper">
                        <div class="page-title-heading">
                            <div class="page-title-icon">
                                <i class="pe-7s-notebook icon-gradient bg-mixed-hopes"></i>
                            </div>
                            <div>
                                Service Call / Complaints List <div class="page-title-subheading"></div>
                            </div>
                        </div>
                        <div class="page-title-actions">
                            <div class="d-inline-block dropdown">

                                <button type="button" (click)="onAdd()" class="btn-shadow btn btn-info">
                                    <i class="fa fa-plus fa-lg pointer m-t-5 blackColor" tooltip="Create"
                                        data-toggle="tooltip" data-placement="top" >&nbsp;&nbsp;</i>ADD NEW SERVICE CALL / COMPLAINT</button>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- --------------- -->
                <div class="col-md-12">
                    <div class="main-card mb-3 card">
                        <div class="card-body">
                            <div class="table-responsive mb-3">
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped custom-datatable">
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div *ngIf="!serviceCallData" class="row">
                    <div class="col-md-12">
                        <div class="main-card mb-3 card">
                            <div class="card-body text-center">
                                <div>No service call / complaints registered.</div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>